import styled from 'styled-components';
import { Theme } from '@getgrover/ui';
import { screens } from 'ggApp/utils/mixins/screens';
import { WithTransparentHeader } from './types';

import { HEADER_HEIGHT_MOBILE, HEADER_HEIGHT_DESKTOP } from './constants';

const handleBackgroundColor = ({
    theme,
    withTransparentHeader,
    isMobile,
}: {
    theme: Theme;
    isMobile?: boolean;
} & WithTransparentHeader): string => {
    if (withTransparentHeader) return 'transparent';
    if (isMobile) return `linear-gradient(${theme.colors.Background} 80%, transparent 20%)`;
    return `linear-gradient(${theme.colors.Background} 70%, transparent 30%)`;
};

export const HeaderContainer = styled.div<
    {
        headerHidden: boolean;
    } & WithTransparentHeader
>`
    position: sticky;
    top: 0;
    z-index: 9;
    transform: translateY(
        ${({ headerHidden }) => (headerHidden ? -Math.abs(HEADER_HEIGHT_MOBILE) : 0)}px
    );
    transition: transform 300ms ease-in-out;
    @media (${screens.tablet}) {
        transform: translateY(
            ${({ headerHidden }) => (headerHidden ? -Math.abs(HEADER_HEIGHT_DESKTOP) : 0)}px
        );
    }
    @media (${screens.desktop}) {
        transform: none;
    }
`;

export const Wrap = styled.div<{ headerLoading: boolean }>`
    ${({ theme, headerLoading }) => (headerLoading ? theme.maxWidth : '')};
    width: 100%;
    min-height: ${HEADER_HEIGHT_MOBILE}px;
    @media (${screens.tablet}) {
        min-height: ${HEADER_HEIGHT_DESKTOP}px;
    }
    position: inherit;
`;

export const LoaderWrapper = styled.div`
    ${({ theme }) => theme.maxWidth};
    padding-left: 0px;
    padding-right: 0px;
    padding-bottom: 20px;
`;
